export default __webpack_public_path__ + "static/media/Group15.f4318388.png";